<div class="flex justify-between mb-3">
	<app-anchor type="static" url=".." class="mr-2"
		><h4>Fire Insurance</h4></app-anchor
	>
	<h4 class="flex-1">/ Edit Fire insurance Agent</h4>
</div>
<app-container type="dark" class="mt-2">
	<div>
		<app-create-employee-side-form
			label="Edit Agent"
			[minify]="true"
			(onSubmit)="_onSubmit($event)"
			(onCancel)="_onCancel()"
			[employee]="fireInsuranceAgent"
			[company]="fireInsuranceCompany"
		>
		</app-create-employee-side-form>
	</div>
</app-container>
